// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var GraphqlHelpers = require("../GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_Geocode = require("./CommonTypes_Geocode.bs.js");
var CommonTypes_GeoState = require("./CommonTypes_GeoState.bs.js");
var CommonTypes_Timezone = require("./CommonTypes_Timezone.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var decode = include.decode;

var encode = include.encode;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var Id_fromInt = include.fromInt;

var Id_fromString = include.fromString;

var Id_toInt = include.toInt;

var Id_toString = include.toString;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: Id_fromInt,
  fromString: Id_fromString,
  toInt: Id_toInt,
  toString: Id_toString,
  decode: decode,
  encode: encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var include$1 = TypeUtils.MakeOpaqueStringType({});

var fromString = include$1.fromString;

var toString = include$1.toString;

function parse$1(param) {
  return Relude_Globals.$great$great(fromString, Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: toString
};

var ShortCode_decode = include$1.decode;

var ShortCode_encode = include$1.encode;

var ShortCode_compare = include$1.compare;

var ShortCode_eq = include$1.eq;

var ShortCode_Ord = include$1.Ord;

var ShortCode_Set = include$1.$$Set;

var ShortCode_Map = include$1.$$Map;

var ShortCode = {
  fromString: fromString,
  toString: toString,
  decode: ShortCode_decode,
  encode: ShortCode_encode,
  compare: ShortCode_compare,
  eq: ShortCode_eq,
  Ord: ShortCode_Ord,
  $$Set: ShortCode_Set,
  $$Map: ShortCode_Map,
  GraphQL_API: GraphQL_API$1
};

var Raw = {};

var query = "fragment CommonTypes_City on City   {\nalcCertLink  \ncityName  \ncode  \nid  \nfoodHandlersLink  \ngeoState  {\n...CommonTypes_GeoState   \n}\n\ninstantOrientationsEnabledAt  \nlat  \nlaunchedAt  \nlng  \ntimezone  \n}\n" + CommonTypes_GeoState.query;

function parse$2(value) {
  var value$1 = value.alcCertLink;
  var value$2 = value.foodHandlersLink;
  var value$3 = value.geoState;
  var value$4 = value.instantOrientationsEnabledAt;
  var value$5 = value.launchedAt;
  return {
          alcCertLink: !(value$1 == null) ? value$1 : undefined,
          cityName: value.cityName,
          code: Relude_Globals.$great$great(fromString, Relude_Option.getOrThrow, value.code),
          id: parse(value.id),
          foodHandlersLink: !(value$2 == null) ? value$2 : undefined,
          geoState: CommonTypes_GeoState.verifyArgsAndParse("CommonTypes_GeoState", value$3),
          instantOrientationsEnabledAt: !(value$4 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$4)) : undefined,
          lat: value.lat,
          launchedAt: !(value$5 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$5)) : undefined,
          lng: value.lng,
          timezone: CommonTypes_Timezone.GraphQL_API.parse(value.timezone)
        };
}

function serialize(value) {
  var value$1 = value.timezone;
  var value$2 = Curry._1(CommonTypes_Timezone.GraphQL_API.serialize, value$1);
  var value$3 = value.lng;
  var value$4 = value.launchedAt;
  var launchedAt = value$4 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$4)) : null;
  var value$5 = value.lat;
  var value$6 = value.instantOrientationsEnabledAt;
  var instantOrientationsEnabledAt = value$6 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$6)) : null;
  var value$7 = value.geoState;
  var geoState = CommonTypes_GeoState.serialize(value$7);
  var value$8 = value.foodHandlersLink;
  var foodHandlersLink = value$8 !== undefined ? value$8 : null;
  var value$9 = value.id;
  var value$10 = Curry._1(encode, value$9);
  var value$11 = value.code;
  var value$12 = Curry._1(toString, value$11);
  var value$13 = value.cityName;
  var value$14 = value.alcCertLink;
  var alcCertLink = value$14 !== undefined ? value$14 : null;
  return {
          alcCertLink: alcCertLink,
          cityName: value$13,
          code: value$12,
          id: value$10,
          foodHandlersLink: foodHandlersLink,
          geoState: geoState,
          instantOrientationsEnabledAt: instantOrientationsEnabledAt,
          lat: value$5,
          launchedAt: launchedAt,
          lng: value$3,
          timezone: value$2
        };
}

function verifyArgsAndParse(_CommonTypes_City, value) {
  return parse$2(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  return {
          alcCertLink: param.alcCertLink,
          cityName: param.cityName,
          code: param.code,
          id: param.id,
          foodHandlersLink: param.foodHandlersLink,
          geocode: CommonTypes_Geocode.make(param.lat, param.lng),
          geoState: param.geoState,
          instantOrientationsEnabledAt: param.instantOrientationsEnabledAt,
          launchedAt: param.launchedAt,
          timezone: param.timezone
        };
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

var compareByName = Curry._1(Relude_String.compareWithConversion, (function (param) {
        return param.cityName;
      }));

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var Ord = {
  eq: eq$1,
  compare: compare$1
};

var $$Set = Relude_Set.WithOrd(Ord);

function eq$2(param, param$1) {
  return Relude_Option.eqBy(eq$1, param, param$1);
}

function compare$2(param) {
  var a = param[0];
  if (a === undefined) {
    if (param[1] !== undefined) {
      return "less_than";
    } else {
      return "equal_to";
    }
  }
  var b = param[1];
  if (b !== undefined) {
    return compare$1(a, b);
  } else {
    return "greater_than";
  }
}

function compare$3(param, param$1) {
  return Relude_Function.curry2(compare$2, param, param$1);
}

var include$2 = Relude_Set.WithOrd({
      eq: eq$2,
      compare: compare$3
    });

var fromList = include$2.fromList;

var partial_arg = Relude_List.map(Relude_Option.pure);

function partial_arg$1(param) {
  return Relude_Globals.$great$great($$Set.toList, partial_arg, param);
}

function partial_arg$2(param) {
  return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                return Relude_List.prepend(undefined, param);
              }), param);
}

function fromSet(param) {
  return Relude_Globals.$great$great(partial_arg$2, fromList, param);
}

var SetWithNone_Comparable = include$2.Comparable;

var SetWithNone_empty = include$2.empty;

var SetWithNone_fromArray = include$2.fromArray;

var SetWithNone_isEmpty = include$2.isEmpty;

var SetWithNone_contains = include$2.contains;

var SetWithNone_add = include$2.add;

var SetWithNone_mergeMany = include$2.mergeMany;

var SetWithNone_remove = include$2.remove;

var SetWithNone_removeMany = include$2.removeMany;

var SetWithNone_update = include$2.update;

var SetWithNone_toggle = include$2.toggle;

var SetWithNone_union = include$2.union;

var SetWithNone_intersect = include$2.intersect;

var SetWithNone_diff = include$2.diff;

var SetWithNone_subset = include$2.subset;

var SetWithNone_compare = include$2.compare;

var SetWithNone_eq = include$2.eq;

var SetWithNone_forEach = include$2.forEach;

var SetWithNone_foldLeft = include$2.foldLeft;

var SetWithNone_foldRight = include$2.foldRight;

var SetWithNone_all = include$2.all;

var SetWithNone_any = include$2.any;

var SetWithNone_filter = include$2.filter;

var SetWithNone_keep = include$2.keep;

var SetWithNone_filterNot = include$2.filterNot;

var SetWithNone_reject = include$2.reject;

var SetWithNone_partition = include$2.partition;

var SetWithNone_length = include$2.length;

var SetWithNone_toArray = include$2.toArray;

var SetWithNone_toList = include$2.toList;

var SetWithNone_minimum = include$2.minimum;

var SetWithNone_maximum = include$2.maximum;

var SetWithNone_get = include$2.get;

var SetWithNone_getOrElse = include$2.getOrElse;

var SetWithNone_split = include$2.split;

var SetWithNone = {
  Comparable: SetWithNone_Comparable,
  empty: SetWithNone_empty,
  fromArray: SetWithNone_fromArray,
  fromList: fromList,
  isEmpty: SetWithNone_isEmpty,
  contains: SetWithNone_contains,
  add: SetWithNone_add,
  mergeMany: SetWithNone_mergeMany,
  remove: SetWithNone_remove,
  removeMany: SetWithNone_removeMany,
  update: SetWithNone_update,
  toggle: SetWithNone_toggle,
  union: SetWithNone_union,
  intersect: SetWithNone_intersect,
  diff: SetWithNone_diff,
  subset: SetWithNone_subset,
  compare: SetWithNone_compare,
  eq: SetWithNone_eq,
  forEach: SetWithNone_forEach,
  foldLeft: SetWithNone_foldLeft,
  foldRight: SetWithNone_foldRight,
  all: SetWithNone_all,
  any: SetWithNone_any,
  filter: SetWithNone_filter,
  keep: SetWithNone_keep,
  filterNot: SetWithNone_filterNot,
  reject: SetWithNone_reject,
  partition: SetWithNone_partition,
  length: SetWithNone_length,
  toArray: SetWithNone_toArray,
  toList: SetWithNone_toList,
  minimum: SetWithNone_minimum,
  maximum: SetWithNone_maximum,
  get: SetWithNone_get,
  getOrElse: SetWithNone_getOrElse,
  split: SetWithNone_split,
  fromSet: fromSet
};

var $$Map = Relude_Map.WithOrd(Ord);

exports.Id = Id;
exports.ShortCode = ShortCode;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$2;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.compare = compare$1;
exports.compareByName = compareByName;
exports.eq = eq$1;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
/* include Not a pure module */
